import * as z from "zod";

export const premiumSearchSchema = z.object({
  checkout: z.enum(["success"]).optional(),
});

const optionalMonthSearchSchema = z.object({
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional(),
});

export const archiveSearchSchema = optionalMonthSearchSchema;

export const hiscoresSearchSchema = optionalMonthSearchSchema;
